import i18next from 'i18next';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';
const getDefaultState = () => {
    return {
        includeText: '',
        includeValues: [],
        excludeText: '',
        excludeValues: [],
    };
};
class TextFilterWithExclude extends Component {
    constructor(props) {
        super(props);
        this.destroy = () => {
            this.setState(getDefaultState());
        };
        this.onIncludeChange = (event) => {
            const newValue = event.target.value;
            if (this.state.includeText !== newValue) {
                this.setState({
                    includeText: newValue,
                });
            }
        };
        this.onExcludeChange = (event) => {
            const newValue = event.target.value;
            if (this.state.excludeText !== newValue) {
                this.setState({
                    excludeText: newValue,
                });
            }
        };
        this.handleFilter = () => {
            const { includeText, excludeText } = this.state;
            let includeValues = [];
            let excludeValues = [];
            if (includeText) {
                includeValues = includeText
                    .replace(/\n/g, ',')
                    .split(',')
                    .map((str) => str.toLowerCase().trim());
            }
            if (excludeText) {
                excludeValues = excludeText
                    .replace(/\n/g, ',')
                    .split(',')
                    .map((str) => str.toLowerCase().trim());
            }
            this.setState({ includeValues, excludeValues }, () => {
                this.props.filterChangedCallback();
            });
        };
        this.state = getDefaultState();
    }
    getModel() {
        const { includeValues, excludeValues } = this.state;
        const model = {};
        if (!includeValues.length && !excludeValues.length) {
            return model;
        }
        let index = 1;
        if (includeValues && includeValues.length) {
            includeValues.forEach((value) => {
                model[`condition${index}`] = {
                    type: 'contains',
                    filter: value,
                    filterType: 'text',
                };
                index++;
            });
        }
        if (excludeValues && excludeValues.length) {
            excludeValues.forEach((value) => {
                model[`condition${index}`] = {
                    type: 'notContains',
                    filter: value,
                    filterType: 'text',
                };
                index++;
            });
        }
        return Object.assign(Object.assign({}, model), { operator: 'OR' });
    }
    setModel(model) {
        if (!model) {
            return this.setState(getDefaultState());
        }
        let includedValues = [];
        let excludedValues = [];
        Object.keys(model).forEach((item) => {
            if (model[item].type === 'contains' && model[item].filter) {
                includedValues.push(model[item].filter);
            }
            else if (model[item].type === 'notContains' && model[item].filter) {
                excludedValues.push(model[item].filter);
            }
        });
        const includeText = includedValues.join('\n');
        const excludeText = excludedValues.join('\n');
        this.setState({ includedValues, excludedValues, includeText, excludeText }, () => {
            // Handle filter must be called here for some reason?!
            this.handleFilter();
        });
    }
    doesFilterPass(params) {
        if (this.props.isUsedInMultifilter) {
            // filtering order is not defined when using multifilter
            // so could not use doesRowPassOtherFilter here
            return true;
        }
        try {
            let rowPasses = false;
            const { includeValues, excludeValues } = this.state;
            includeValues.forEach((val) => {
                if (this.props.valueGetter(params).toString().toLowerCase().includes(val)) {
                    rowPasses = true;
                }
            });
            excludeValues.forEach((val) => {
                if (!this.props.valueGetter(params).toString().toLowerCase().includes(val)) {
                    rowPasses = true;
                }
            });
            return rowPasses;
        }
        catch (e) {
            console.error(e);
            return false;
        }
    }
    isFilterActive() {
        if (!this.state.includeText && !this.state.excludeText) {
            return false;
        }
        return this.state.includeText.length || this.state.excludeText.length;
    }
    afterGuiAttached() {
        this.focus();
    }
    focus() {
        window.setTimeout(() => {
            const container = ReactDOM.findDOMNode(this.refs.input);
            if (container) {
                container.focus();
            }
        });
    }
    render() {
        return ((React.createElement("div", { "data-testid": "div-d7e98d33", className: "p-4 space-y-2" },
            React.createElement("label", { "data-testid": "label-08ff2f73", className: "mb-2 form-label" }, i18next.t('INCLUDE')),
            React.createElement("textarea", { "data-testid": "textarea-5b27d9f6", rows: 5, ref: "input", value: this.state.includeText, onChange: this.onIncludeChange, className: "form-control resize-none" }),
            React.createElement("label", { "data-testid": "label-39f6fb77", className: "mb-2 form-label" }, i18next.t('EXCLUDE')),
            React.createElement("textarea", { "data-testid": "textarea-0247d21f", rows: 5, ref: "input", value: this.state.excludeText, onChange: this.onExcludeChange, className: "form-control resize-none" }),
            React.createElement("div", { "data-testid": "div-c0340931", className: "flex justify-end pt-2" },
                React.createElement("button", { "data-testid": "button-739f9656", className: "button button-green", onClick: () => this.handleFilter() }, i18next.t('FILTER'))))));
    }
}
export default TextFilterWithExclude;
